import loadScript from '../util/loadscript';
export default class Assets {
  static async loadReact() {
    if (window.React) {
      return;
    }
    await loadScript('//g.alicdn.com/??aliyun/dblx/0.1.4/react.min.js,aliyun/dblx/0.1.4/react-dom.min.js');
  }
  static async loadCart() {
    await loadScript('//cart.aliyun.com/renderer?name=miniCart');
  }
}



// WEBPACK FOOTER //
// ./src/components/assets.js